import React from "react";
import { downloadImage } from "shared/data";
import * as notify from "shared/notify";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArchive } from "@fortawesome/free-solid-svg-icons";

const BatchDownload = ({ wipKey, upc, taskKey, sourcePage, isReadOnly }) => {
    const path = `/photography/wips/${wipKey}/wip-shots/bulk-download?upc=${upc}&taskKey=${taskKey}`;

    const linkClick = async () => {
        const file = await downloadImage(path, sourcePage, true);

        if (!file) {
            return notify.error("You do not have permission to perform this action.");
        }

        return file;
    };

    return (
        <button className={classnames("button", { "-disabled": isReadOnly })} title="Bulk Download" onClick={linkClick} disabled={isReadOnly}>
            <FontAwesomeIcon icon={faFileArchive} />
        </button>
    );
};

export default BatchDownload;
